import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const RemoveIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.23 7l.77.77L12.769 12 17 16.23l-.77.77L12 12.769 7.77 17 7 16.23 11.23 12 7 7.77 7.77 7 12 11.231 16.23 7z"
  }
));

export { RemoveIcon };
//# sourceMappingURL=RemoveIcon.js.map
